import { Alert, AlertId } from '../types';

export const Alerts: { [key in AlertId]: Alert } = {
	logout: {
		label: 'auth.alert.logout.success.label',
		content: 'auth.alert.logout.success.content',
		appearance: 'positive',
	},
	'logout-error': {
		label: 'auth.alert.logout.error.label',
		content: 'auth.alert.logout.error.content',
		appearance: 'negative',
	},
	'alerts-updated': {
		label: 'profile.alert.alerts-updated.success.label',
		content: 'profile.alert.alerts-updated.success.content',
		appearance: 'positive',
	},
	'alerts-updated-error': {
		label: 'profile.alert.alerts-updated.error.label',
		content: 'profile.alert.alerts-updated.error.content',
		appearance: 'negative',
	},
	'profile-updated': {
		label: 'profile.alert.profile-updated.success.label',
		content: 'profile.alert.profile-updated.success.content',
		appearance: 'positive',
	},
	'profile-updated-error': {
		label: 'profile.alert.profile-updated.error.label',
		content: 'profile.alert.profile-updated.error.content',
		appearance: 'negative',
	},
	'user-updated': {
		label: 'user.alert.user-updated.success.label',
		content: 'user.alert.user-updated.success.content',
		appearance: 'positive',
	},
	'user-updated-error': {
		label: 'user.alert.user-updated.error.label',
		content: 'user.alert.user-updated.error.content',
		appearance: 'negative',
	},
	'image-upload-error': {
		label: 'alert.file-upload.error.label',
		content: 'alert.file-upload.error.content',
		appearance: 'negative',
	},
	notification: {
		label: 'notification.alert.success.label',
		appearance: 'info',
	},
	'user-not-found': {
		label: 'user.alert.not-found.error.label',
		content: 'user.alert.not-found.error.content',
		appearance: 'negative',
	},
	'loading-data': {
		label: 'data.alert.loading.error.label',
		content: 'data.alert.loading.error.content',
		appearance: 'negative',
	},
	'deleted-user': {
		label: 'user.alert.deleted-user.error.label',
		content: 'user.alert.deleted-user.error.content',
		appearance: 'negative',
	},
	'user-deleted': {
		label: 'user.alert.user-deleted.error.label',
		content: 'user.alert.user-deleted.error.content',
		appearance: 'positive',
	},
	'generic-error': {
		label: 'data.alert.generic.error.label',
		content: 'data.alert.generic.error.content',
		appearance: 'negative',
	},
	'generic-success': {
		label: 'data.alert.generic.success.label',
		content: 'data.alert.generic.success.content',
		appearance: 'positive',
	},
	'invite-not-found': {
		label: 'invite.alert.not-found.error.label',
		content: 'invite.alert.not-found.error.content',
		appearance: 'negative',
	},
	'invite-expired': {
		label: 'invite.alert.expired.error.label',
		content: 'invite.alert.expired.error.content',
		appearance: 'negative',
	},
	'user-already-exists': {
		label: 'user.alert.already-exists.error.label',
		content: 'user.alert.already-exists.error.content',
		appearance: 'negative',
	},
	'deleted-user-already-exists': {
		label: 'user.alert.deleted-already-exists.error.label',
		content: 'user.alert.deleted-already-exists.error.content',
		appearance: 'negative',
	},
	'edit-permissions-error': {
		label: 'user.alert.edit-permissions.error.label',
		content: 'user.alert.edit-permissions.error.content',
		appearance: 'negative',
	},
	'folder-not-found': {
		label: 'folder.alert.not-found.error.label',
		content: 'folder.alert.not-found.error.content',
		appearance: 'negative',
	},
	'file-not-found': {
		label: 'file.alert.not-found.error.label',
		content: 'file.alert.not-found.error.content',
		appearance: 'negative',
	},
	'deleted-folder': {
		label: 'folder.alert.deleted-folder.error.label',
		content: 'folder.alert.deleted-folder.error.content',
		appearance: 'negative',
	},
	'deleted-file': {
		label: 'file.alert.deleted-file.error.label',
		content: 'file.alert.deleted-file.error.content',
		appearance: 'negative',
	},
	'forgot-password': {
		label: 'user.alert.forgot-password.success.label',
		content: 'user.alert.forgot-password.success.content',
		appearance: 'positive',
	},
	'forgot-password-expired': {
		label: 'user.alert.forgot-password-expired.error.label',
		content: 'user.alert.forgot-password-expired.error.content',
		appearance: 'negative',
	},
	'copy-link': {
		label: 'alert.copy-link.success.label',
		content: 'alert.copy-link.success.content',
		appearance: 'positive',
	},
	'copy-link-error': {
		label: 'alert.copy-link.error.label',
		content: 'alert.copy-link.error.content',
		appearance: 'negative',
	},
	'external-link-generated': {
		label: 'alert.external-link-generated.success.label',
		content: 'alert.external-link-generated.success.content',
		appearance: 'positive',
	},
	'inquire-sent': {
		label: 'alert.inquire-sent.success.label',
		content: 'alert.inquire-sent.success.content',
		appearance: 'positive',
	},
	'help-sent': {
		label: 'alert.help-sent.success.label',
		content: 'alert.help-sent.success.content',
		appearance: 'positive',
	},
	'file-downloaded': {
		label: 'alert.file-downloaded.success.label',
		content: 'alert.file-downloaded.success.content',
		appearance: 'positive',
	},
	'file-downloaded-error': {
		label: 'alert.file-downloaded.error.label',
		content: 'alert.file-downloaded.error.content',
		appearance: 'negative',
	},
	'file-downloading': {
		label: 'alert.file-downloading.success.label',
		content: 'alert.file-downloading.success.content',
		appearance: 'info',
	},
	'organization-updated': {
		label: 'organization.alert.organization-updated.success.label',
		content: 'organization.alert.organization-updated.success.content',
		appearance: 'positive',
	},
	'organization-updated-error': {
		label: 'organization.alert.organization-updated.error.label',
		content: 'organization.alert.organization-updated.error.content',
		appearance: 'negative',
	},
	'organization-invite-super-error': {
		label: 'organization.alert.invite-super.error.label',
		content: 'organization.alert.invite-super.error.content',
		appearance: 'negative',
	},
	'organization-chemicals-config-saved': {
		label: 'organization.alert.chemicals-config.success.label',
		content: 'organization.alert.chemicals-config.success.content',
		appearance: 'positive',
	},
	'organization-chemicals-config-error': {
		label: 'organization.alert.chemicals-config.error.label',
		content: 'organization.alert.chemicals-config.error.content',
		appearance: 'negative',
	},
	'companion-code-invalid': {
		label: 'organization.alert.companion-code-invalid.error.label',
		content: 'organization.alert.companion-code-invalid.error.content',
		appearance: 'negative',
	},
	'session-invalidated-expired': {
		label: 'companion.alert.invalidated-expired.error.label',
		content: 'companion.alert.invalidated-expired.error.content',
		appearance: 'negative',
	},
	'session-invalidated-deleted': {
		label: 'companion.alert.invalidated-deleted.error.label',
		content: 'companion.alert.invalidated-deleted.error.content',
		appearance: 'negative',
	},
	'session-invalidated-non-existent': {
		label: 'companion.alert.invalidated-non-existent.error.label',
		content: 'companion.alert.invalidated-non-existent.error.content',
		appearance: 'negative',
	},
	'organization-authentication-config-saved': {
		label: 'organization.alert.authentication-config.success.label',
		content: 'organization.alert.authentication-config.success.content',
		appearance: 'positive',
	},
	'organization-authentication-config-error': {
		label: 'organization.alert.authentication-config.error.label',
		content: 'organization.alert.authentication-config.error.content',
		appearance: 'negative',
	},
	'organization-users-config-saved': {
		label: 'organization.alert.users-config.success.label',
		content: 'organization.alert.users-config.success.content',
		appearance: 'positive',
	},
	'organization-users-config-error': {
		label: 'organization.alert.users-config.error.label',
		content: 'organization.alert.users-config.error.content',
		appearance: 'negative',
	},
	'application-access-denied': {
		label: 'auth.alert.application-access-denied.error.label',
		content: 'auth.alert.application-access-denied.error.content',
		appearance: 'negative',
	},
	'organization-not-found': {
		label: 'organization.alert.not-found.error.label',
		content: 'organization.alert.not-found.error.content',
		appearance: 'negative',
	},
	'invite-sent': {
		label: 'user.alert.invite-sent.success.label',
		content: 'user.alert.invite-sent.success.content',
		appearance: 'positive',
	},
	copy: {
		label: 'alert.copy.success.label',
		content: 'alert.copy.success.content',
		appearance: 'positive',
	},
	'copy-error': {
		label: 'alert.copy.error.label',
		content: 'alert.copy.error.content',
		appearance: 'negative',
	},
	'external-content-not-found': {
		label: 'external.alert.content-not-found.error.label',
		content: 'external.alert.content-not-found.error.content',
		appearance: 'negative',
	},
};
